import { createGetOptionsNoPropsFn } from '@common/selectOptions.services';
import { ITagTypeOption } from './tag.models';

export const apiRoutes = {
  tagTypeOptions: '/Tags/TagType/Options',
};
export const getAllTagTypeOptionsAsync = createGetOptionsNoPropsFn<ITagTypeOption>(apiRoutes.tagTypeOptions);
